import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import CopyTextField from 'cityads-v3/components/CopyTextField/CopyTextField';

import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils';

import {
  getRemoteAuth,
  changeRemoteAuth,
} from 'cityads-v3/actions/apiAuth';

import classes from './OAuth.scss';

@connect(
  state => ({
    value     : state.apiAuth.remoteAuth,
    isLoading : state.apiAuth.isRemoteAuthLoading,
    isLoaded  : state.apiAuth.isRemoteAuthLoaded,
    isChanging: state.apiAuth.isRemoteAuthChanging,
    errors    : state.apiAuth.remoteAuthChangingErrors,
  }),
  dispatch => bindActionCreators({
    getRemoteAuth,
    changeRemoteAuth,
  }, dispatch),
)
@withTranslation(['Publisher'], { i18n, wait: !!window })
export default class RemoteAuth extends Component {
  static propTypes = {
    t               : PropTypes.func.isRequired,
    value           : PropTypes.string,
    isLoading       : PropTypes.bool,
    isLoaded        : PropTypes.bool,
    getRemoteAuth   : PropTypes.func.isRequired,
    changeRemoteAuth: PropTypes.func.isRequired,
    isChanging      : PropTypes.bool,
    errors          : PropTypes.arrayOf(PropTypes.string),
  }

  componentDidMount() {
    const { isLoading, isLoaded, getRemoteAuth } = this.props;

    if (!isLoading && !isLoaded) {
      getRemoteAuth();
    }
  }

  render() {
    const { t, value, isLoading, changeRemoteAuth, isChanging, errors } = this.props;

    if (isLoading) {
      return (
        <div className={classes.сardLoading}>
          <CircularProgress size={48} />
        </div>
      );
    }

    return (
      <div className={classes.card}>
        <div className={classes.inputContainer}>
          <CopyTextField
            id = "apiPageRemoteAuthInput"
            label = {t('api.remoteAuthForm.field')}
            value = {value || ''}
            copyButtonTitle = {t('main:buttons.copy')}
            onCopyText = {() => {
              amplitudeSendEvent('makeActions', 'd-v1-e15', 'office', 'api_remote_auth_copy');
            }}
          />
        </div>

        <div className={classes.buttonContainer}>
          <Button
            id        = "apiPageRemoteAuthChangeButton"
            variant   = "contained"
            color     = "primary"
            className = {classes.button}
            onClick   = {changeRemoteAuth}
            disabled  = {isChanging}
          >
            {t('api.remoteAuthForm.button')}
          </Button>
          {isChanging ? <CircularProgress size={24} className={classes.buttonProgress} /> : null}
        </div>

        {(errors && errors.length) ? (
          <div className={classes.errors}>
            {errors.map((err, idx) => (
              <div className={classes.error} key={idx}>
                {err}
              </div>
            ))}
          </div>
        ) : null}

        <div className={classes.note}>
          <div className={classes.attention}>
            {t('api.remoteAuthForm.attention')}
          </div>
          <p>
            {t('api.remoteAuthForm.text1')}
          </p>
          <p>
            {t('api.remoteAuthForm.text2')}
          </p>
        </div>
      </div>
    );
  }
}
